import * as Mutation from './mutation-types'

export default {
  async buscaGeralPlataforma ({ commit }, termoBusca) {
    commit(Mutation.SET_TERMO_BUSCA_GERAL_PLATAFORMA, termoBusca)
  }
}
